module.exports = __webpack_public_path__ + "img/knu_thumbnail.64023ad5.jpg";